if (!customElements.get('video-overlay')) {
  class VideoOverlay extends HTMLElement {
    constructor() {
      super();
      const overlay_trigger = document.querySelector('[data-video-overlay]');
      const close_trigger = document.querySelector('[data-close-overlay');
      const modal = document.getElementById(`video-overlay-${this.dataset.index}`);

      const clickHandler = (e) => {
        e.preventDefault();
        if (modal) {
          modal.classList.remove('hidden');
          modal.classList.add('flex');
          modal.setAttribute('aria-hidden', 'false');
          modal.removeAttribute('disabled');
          modal.inert = false;
          document.body.style.overflowY = 'hidden';
        }
      };

      if (overlay_trigger) {
        overlay_trigger.addEventListener('click', clickHandler);
      }

      if (close_trigger) {
        close_trigger.addEventListener('click', this.closeModal.bind(this));
      }

      document.addEventListener('keydown', this.keydownHandler.bind(this));
    }

    closeModal() {
      const modal = document.getElementById(`video-overlay-${this.dataset.index}`);
      modal.classList.add('hidden');
      modal.classList.add('remove');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('disabled', 'disabled');
      modal.inert = true;
      document.body.style.overflowY = 'auto';
    }

    keydownHandler(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  }

  window.VideoOverlay = VideoOverlay;

  customElements.define('video-overlay', VideoOverlay);
}
